import { Box, Button, Grid, Link, Typography } from "@mui/material";
import { Map } from "schemas/functions";

interface Props {
  handleNext: (updatedForm?: Map) => void;
}

const WelcomePage = ({ handleNext }: Props) => {
  return (
    <>
      <Typography
        variant="h2"
        sx={{ fontSize: { xs: 30, md: 50 } }}
        textAlign={"center"}
      >
        👋 Welcome to{" "}
        <Box component="span" sx={{ color: "primary.main" }}>
          Bento
        </Box>
      </Typography>
      <Typography
        variant="h2"
        textAlign={"center"}
        sx={{ mb: 3, fontSize: { xs: 14, md: 20 } }}
      >
        <Box component="span">
          The perfect pitching tool for content creators
        </Box>
      </Typography>

      <Grid container justifyContent={"center"} gap={3} sx={{ mb: 3 }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ p: 3, backgroundColor: "white", borderRadius: 4 }}
        >
          <Typography variant="h5" gutterBottom>
            ✨ 600k+ Brand Contacts
          </Typography>

          <Typography>
            Endless opportunities across the globe to find the perfect brands
            for your content.
          </Typography>
        </Grid>
        <Grid
          item
          xs
          md
          sx={{ p: 3, backgroundColor: "purple.main", borderRadius: 4 }}
        >
          <Typography variant="h5" gutterBottom>
            <Box
              component="i"
              className="fa-regular fa-envelopes-bulk"
              sx={{ mr: 1 }}
            />{" "}
            Automated Follow-ups
          </Typography>

          <Typography>
            Schedule your follow-ups <strong>in advance</strong>. Bento cancels
            them automatically if you've heard back from the brand.
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent={"center"} gap={3}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ p: 3, backgroundColor: "yellow.main", borderRadius: 4 }}
        >
          <Typography variant="h5" gutterBottom>
            <Box
              component="i"
              className="fa-brands fa-instagram"
              sx={{ mr: 1 }}
            />
            Build Your Pitch List From Instagram
          </Typography>

          <Typography>
            Connect with{" "}
            <Link
              href="https://instagram.com/onbento"
              sx={{ textDecoration: "none", fontWeight: 600 }}
              target="_blank"
            >
              Bento on Instagram
            </Link>{" "}
            to curate your brand pitch list with your favorite creators.
          </Typography>
        </Grid>
        <Grid
          item
          xs
          md
          sx={{ p: 3, backgroundColor: "white", borderRadius: 4 }}
        >
          <Typography variant="h5" gutterBottom>
            👆 Pitch to the Right Person
          </Typography>

          <Typography>
            See which brands have recently been emailed, responded, and have
            discussed partnerships with creators.
          </Typography>
        </Grid>
      </Grid>

      <Typography
        textAlign={"center"}
        sx={{ mt: 3, mb: 1, fontSize: { xs: 12, md: 16 } }}
      >
        Ready to land some brand deals? 👀
      </Typography>

      <Grid
        container
        justifyContent="center"
        flexDirection={"column"}
        alignItems="center"
        gap={1}
      >
        <Button
          disableElevation
          onClick={() => handleNext(undefined)}
          variant="contained"
          sx={{ fontSize: 16, px: 2 }}
        >
          Let's Get Started
          <Box
            component="i"
            className="fa-regular fa-circle-arrow-right"
            sx={{ ml: 1 }}
          />
        </Button>
      </Grid>
    </>
  );
};

export default WelcomePage;
